export const IssueKind = {
  userReport: 'USER_REPORT',
  autoError: 'AUTO_ERROR',
} as const;

export type IssueKind = (typeof IssueKind)[keyof typeof IssueKind];

export const IssueSeverity = {
  low: 'LOW',
  medium: 'MEDIUM',
  high: 'HIGH',
  critical: 'CRITICAL',
} as const;

export type IssueSeverity = (typeof IssueSeverity)[keyof typeof IssueSeverity];

export const IssueStatus = {
  new: 'NEW',
  triaged: 'TRIAGED',
  inProgress: 'IN_PROGRESS',
  resolved: 'RESOLVED',
  wontFix: 'WONT_FIX',
} as const;

export type IssueStatus = (typeof IssueStatus)[keyof typeof IssueStatus];

/**
 * Everything past `title` is best-effort diagnostic context collected by the client.
 * A failed probe must never stop the report from being sent.
 */
export type IssueReportCreate = {
  title: string;
  description?: string;
  kind?: IssueKind;
  severity?: IssueSeverity;
  route?: string;
  patientId?: string;
  scanId?: string;
  appVersion?: string;
  userAgent?: string;
  platform?: string;
  screenInfo?: string;
  gpuVendor?: string;
  gpuRenderer?: string;
  errorStack?: string;
  /** JSON string: devRuntime log tail plus extra diagnostics. */
  context?: string;
  screenshotBase64?: string;
};

export type IssueReportSummary = {
  id: string;
  title: string;
  kind: IssueKind;
  severity: IssueSeverity;
  status: IssueStatus;
  route?: string | null;
  clinicId?: string | null;
  clinicName?: string | null;
  reportedByEmail?: string | null;
  createdAt: string;
  hasScreenshot: boolean;
};

export type IssueReportDetail = IssueReportSummary & {
  description?: string | null;
  patientId?: string | null;
  scanId?: string | null;
  appVersion?: string | null;
  userAgent?: string | null;
  platform?: string | null;
  screenInfo?: string | null;
  gpuVendor?: string | null;
  gpuRenderer?: string | null;
  errorStack?: string | null;
  context?: string | null;
  resolutionNote?: string | null;
  resolvedAt?: string | null;
  resolvedByEmail?: string | null;
  updatedAt: string;
};

export type IssueReportUpdate = {
  status?: IssueStatus;
  severity?: IssueSeverity;
  resolutionNote?: string;
};

export type IssueReportQuery = {
  status?: IssueStatus;
  severity?: IssueSeverity;
  kind?: IssueKind;
  clinicId?: string;
  search?: string;
};
